import React, { useState } from "react";

import { BREAKPOINTS } from "../../constants/styles";
import { Col, Typography } from "antd";
import { ARROW_LIGHT, ARROW_OPENER } from "../../constants/svgs";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../constants/routes";
import { VIEWS } from "../../constants/global";

import CustomRow from "../../shared/costum-row/costum-row";
import CustomImage from "../../shared/custom-image/custom-image";
import useBreakpoints from "../../hooks/use-breakpoints";
import CustomDivider from "../../shared/custom-divider/custom-divider";

import "./styles.scss";

const { Text } = Typography;

interface CaseProject {
  id: number;
  title: string;
  description: string;
  imageSrc: string;
  logo?: {
    src: string;
    marginTop: number;
  };
}

interface CaseCardProps {
  caseProject: CaseProject;
}

const CaseCard: React.FC<CaseCardProps> = ({ caseProject }) => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const currentBreakpoint = useBreakpoints();

  const isMobile = currentBreakpoint === BREAKPOINTS.MOBILE.type;

  const handleClick = () => {
    navigate(`${routes[VIEWS.CASE_DETAILS].staticPath}/${caseProject.id}`);
  };

  const CaseImage = (
    <Col xxl={12} xl={12} lg={15} md={14} sm={24}>
      <CustomImage
        src={caseProject.imageSrc}
        className="CaseCard-image"
        alt="logo"
      />
    </Col>
  );

  console.log({
    caseProject,
  });

  const CaseContent = (
    <Col xxl={12} xl={12} lg={9} md={10} sm={24}>
      <div className="CaseCard-content-wrapper">
        <div className="CaseCard-content">
          <Text className="CaseCard-title">{caseProject.title}</Text>
          <Text className="CaseCard-description">
            {caseProject.description}
          </Text>
          {caseProject.logo && (
            <div className="CaseCard-company-logo-container">
              <img
                src={caseProject.logo.src}
                alt="case"
                className="CaseCard-company-logo"
                style={{ marginTop: caseProject.logo.marginTop }}
              />
            </div>
          )}
        </div>
        <div className="CaseCard-content-button">
          <Link
            className="CaseCard-btn-label"
            to={`${routes[VIEWS.CASE_DETAILS].staticPath}/${caseProject.id}`}
          >
            Read more
          </Link>
          {isHovered ? ARROW_OPENER : ARROW_LIGHT}
        </div>
      </div>
    </Col>
  );

  const FirstCol = isMobile ? CaseContent : CaseImage;
  const SecondCol = isMobile ? CaseImage : CaseContent;

  return (
    <CustomRow
      className="CaseCard"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
    >
      <CustomDivider />
      <CustomRow gutter={[0, 0]} className="CaseCard-row">
        {FirstCol}
        {SecondCol}
      </CustomRow>
    </CustomRow>
  );
};

export default CaseCard;
